module.exports = __webpack_public_path__ + "static/media/test3_4.f44ec1f8.png";